import React, { PropsWithChildren } from 'react';
import { useMediaQuery } from 'react-responsive';

import { MIN_XS, MIN_MD, MIN_LG } from '../constants/breakpoints';

type Props = PropsWithChildren<{}>;

export const useIsMobile = () => useMediaQuery({ maxWidth: MIN_MD - 1 });

export const Mobile = ({ children }: Props) => (useIsMobile() ? <>{children}</> : null);

export const useIsTablet = () => useMediaQuery({ minWidth: MIN_MD, maxWidth: MIN_LG - 1 });

export const Tablet = ({ children }: Props) => (useIsTablet() ? <>{children}</> : null);

export const useIsDesktopOrTablet = () => useMediaQuery({ minWidth: MIN_MD });

export const DesktopAndTablet = ({ children }: Props) => (useIsDesktopOrTablet() ? <>{children}</> : null);

export const useIsDesktop = () => useMediaQuery({ minWidth: MIN_LG });

export const Desktop = ({ children }: Props) => (useIsDesktop() ? <>{children}</> : null);

// e.g. iPhone 5 and others
export const useIsExtraSmallDevice = () => useMediaQuery({ maxWidth: MIN_XS });
